import { Routes } from '@angular/router';

import { MsalGuard } from '@azure/msal-angular';
import { authGuard, initRolesGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [initRolesGuard, MsalGuard, authGuard],
    children: [
      {
        title: 'Configuration',
        loadComponent: () =>
          import(
            './features/configuration/configuration-form/configuration.component'
          ),
        path: 'configuration',
      },
      {
        title: 'Exports History',
        loadComponent: () =>
          import(
            './features/history/components/export-history/export-history.component'
          ),
        path: '',
      },
    ],
  },
  {
    title: 'unauthorized',
    loadComponent: () =>
      import('./features/unauthorized/unauthorized.component'),
    path: 'unauthorized',
  },
];
